/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.years'},
});

const YearsItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/calendar-year"
    title={messages.title}
  />
);

export default YearsItem;
